<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan Art">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">

             <w-flex class="mt3 filter-row">
                <div class="filter-col" v-if="!$zutil.role('1')">
                   <b> Negeri : {{negeri_user.nama ?? ''}}</b>
                </div>
                <div class="filter-col" v-if="$zutil.role('1')">
                    <w-select class="mt4 role-selector" :items="negeri" v-model="pencarian.lkp_negeri_id" @input="getDaerah(pencarian.lkp_negeri_id)" label="Negeri" placeholder="-----SEMUA-----" outlined color="primary" large dark v-if="$zutil.role('1')" />
               </div>
            </w-flex>
            <br>

             <w-flex class="mt3 filter-row">
                <div class="filter-col">
                    <z-select style="margin:5px;" :items="daerah" class="mt4" label="Daerah"  v-model="pencarian.lkp_daerah_id"/>
                </div>
                <div class="filter-col">
                     <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="Premis"/>
                </div>
                <div class="filter-col">
                    <z-select style="margin:5px;" :items="status_bunting" v-model="pencarian.bunting" label="Status Kebuntingan"/>
                </div>
            </w-flex>

            <w-flex class="mt3 filter-row">
                <div class="filter-col">
                     <z-select style="margin:5px; " v-model="pencarian.lkp_art_id" :items="lkp_art" label="Jenis Perkhidmatan" />
                </div>
                <div class="filter-col">
                    <z-input style="margin:5px;" min="0" max="4" type="number" label="No. Inseminasi" v-model="pencarian.bil_inseminasi" />
                </div>
                <div class="filter-col">
                    <w-input 
                        label="Tarikh AI/ET" 
                        type="date" 
                        v-model="pencarian.tarikh_ai"
                    />
                </div>
            </w-flex>

            <w-flex class="mt3 filter-row">
                <div class="filter-col">
                     <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian.lkp_ternakan_id" @input="getJurusanCarian(pencarian.lkp_ternakan_id)" /> 
                </div>
                <div class="filter-col">
                    <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian.lkp_jurusan_id" @input="getBakaCarian(pencarian.lkp_jurusan_id)" />
                </div>
                <div class="filter-col">
                    <z-select style="margin:5px; " v-model="pencarian.lkp_baka_id" :items="lkp_baka" label="Baka" />
                </div>
            </w-flex>

            <w-flex class="mt3 filter-row">
                <div class="filter-col">
                    <w-select class="mt4" :items="lkp_status" label="Status Permohonan"  v-model="pencarian.lkp_status_id" multiple />
                </div>
                <div class="filter-col">
                </div>
                <div class="filter-col">
                </div>
            </w-flex>
          
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN ART'">
          <template #title>
            SENARAI LAPORAN ART
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 900px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                        BIL
                     </th>

                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" >
                        NEGERI 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" >
                        DAERAH 
                     </th>
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" >
                        ID | NAMA PREMIS 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" >
                        JENIS PERKHIDMATAN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        NO PERMOHONAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        NO.PENDAFTARAN 
                     </th>
                    <!--  <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        TARIKH PEMERIKSAAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        TARIKH CHECK-IN
                     </th> -->
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                       ID | NAMA TERNAKAN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        UMUR
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        JENIS TERNAKAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        JURUSAN TERNAKAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        BAKA 
                     </th>
                    <!--  <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        TARIKH SINKRO TERDAHULU
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        TARIKH AI TERDAHULU
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        TARIKH BERANAK TERDAHULU 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        SKOR BADAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        STATUS KEBUNTINGAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        USIA KEBUNTINGAN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        TARIKH JANGKAAN KELAHIRAN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        CATATAN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        STATUS PEMERIKSAAN 
                     </th> -->
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        JENIS SEMEN  
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        NO INSEMINASI
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        TARIKH AI
                     </th>
                    <!--  <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        STATUS KESIHATAN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        SUMBER SEMEN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        ID TERNAKAN SEMEN 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        NO BATCH SEMEN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        HARGA SEMEN
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        BIL STRAW SEMEN DISUNTIK 
                     </th> -->
                      <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" >
                        STATUS PERMOHONAN
                     </th>
                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="15"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">
                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                        {{ (items.current_page - 1) * items.per_page + ind + 1 }}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_negeri ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_daerah ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_premis ?? '-'}} | {{dt.nama_premis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_perkhidmatan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kode ?? '-'}}</td>
                       <!--  <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tarikh_pemeriksaan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_checkin)}}</td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_ternakan ?? '-'}} | {{dt.nama ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.umurbulan(dt.tarikh_lahir)}}</td>


                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurusan_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_baka ?? '-'}}</td>
                        <!-- <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_sinkronisasi)}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_suntik)}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_beranak)}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skor_badan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.bunting == 1"> Bunting</template>
                            <template v-else>Tidak Bunting</template>
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.usia_bunting_art ?? dt.usia_bunting_art}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.jankaan_kelahiran ?? dt.jankaan_kelahiran_art)}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.catatan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                            <template v-if="dt.status_pemeriksaan==1">LULUS</template>
                            <template v-else>TIDAK LULUS</template>
                        </td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_semen ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.bil_inseminasi ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh_ai)}}</td><!-- 
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_status_kesihatan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_kategori_semen ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_ternakan_semen ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_batch ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.harga_straw ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.bil_straw ?? '-'}}</td> -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_status_art ?? '-'}}</td>
                     </tr>
                  </template>
                </tbody>
              </table>
              <br><br>

            </div>
          </div>
          
        <table style="border:none;" width="100%">
          <tbody>
            <tr>
                <td style="border: none; " width="75%" >
                    <div class="per-page-control">
                        <label for="perPage" class="per-page-label">Rekod per halaman:</label>
                        <select v-model="perPage" @change="changePerPage" id="perPage" class="per-page-select">
                            <option v-for="opt in perPageOptions" :key="opt" :value="opt">
                               {{ opt }}
                            </option>
                        </select>
                    </div>
                </td>
                <td style="border: none; " width="25%"  align="right">
                    <nav class="pagination">
                        <button class="pagination-btn" :disabled="!items.prev_page_url" @click="paginate(items.prev_page_url)">
                            Sebelumnya
                        </button>
                        <span class="pagination-info">
                            {{ items.current_page }} dari {{ items.last_page }}
                        </span>

                        <button class="pagination-btn" :disabled="!items.next_page_url" @click="paginate(items.next_page_url)">
                            Seterusnya
                        </button>
                    </nav>
                </td>
            </tr>
          </tbody>
        </table>
        </w-card>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->
        <br>
        <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'BILANGAN ART'">
            <template #title>
                BILANGAN ART
            </template>
            <div class="trend-grid">
                <div class="trend-box">
                 <!-- <div class="w-card__content content-hardcode mb3"> -->
                    <w-form ref="form_chart" v-model="form_chart.valid" @validate="validateFormChart" @success="success">
                        <w-flex class="mt3">
                           
                           <z-select style="margin:5px; " v-model="form_chart.jenis_graf"
                              :items="[
                                 { value: 1, label: 'PIE' },
                                 { value: 2, label: 'BAR' },
                                 { value: 3, label: 'LINE BAR' },
                              ]"
                              label="Jenis Graf"
                              :validators="[validators.required]"
                           />
                           <z-select style="margin:5px; " v-model="form_chart.exis_x"
                              :items="[
                                 { value: 1, label: 'Jurusan' },
                                 { value: 2, label: 'Baka' },
                                 { value: 3, label: 'Jenis Ternakan' },
                                 { value: 4, label: 'Negeri' },
                                 { value: 5, label: 'Daerah' },
                              ]"
                              label="Axis X"
                              :validators="[validators.required]"
                           />
                           <z-select style="margin:5px; " v-model="form_chart.exis_y"
                              :items="[
                                 { value: 1, label: 'Count Butiran' },
                              ]"
                              label="Axis Y"
                              :validators="[validators.required]"
                           />
                           &nbsp;
                           <w-input label="Tajuk" v-model="form_chart.tajuk" :validators="[validators.required]"/>
                        </w-flex> 
                        <w-flex class="mt3" >
                           
                            <div class="filter-col" v-if="$zutil.role('1')">
                                <w-select class="mt4 role-selector" :items="negeri" v-model="form_chart.lkp_negeri_id"  label="Negeri" placeholder="-----SEMUA-----" outlined color="primary" large dark v-if="$zutil.role('1') && form_chart.exis_x == 5" />
                            </div>
                        </w-flex> 
                     </w-form>
                     <br>
                        <w-flex justify-end class="mt2">

                            <w-button class="ml1" :loading="form_chart.loading" @click="$refs.form_chart.validate()">JANA</w-button>
                            
                        </w-flex>
                        <br><br>

                        <w-flex justify-end class="mt2">
                            <w-button class="ml1" :disabled="!chart_data || chart_data.length <= 1" @click="downloadChart">JANA GRAF (PNG)</w-button>
                            
                        </w-flex>
                        <br>
                        <br>
                    <!-- </div> -->
                </div>

                <div class="trend-box">

                    <template v-if="chart_jenis == 1">
                        <GChart 
                        type="PieChart" 
                        :data="chart_data" 
                        :options="{ title: chart_title , legend: { position: 'right' },  width: 1250,
                        height: 575, }"
                        ref="gchart"
                        @ready="onChartReady"/>
                    </template>

                    <template v-else-if="chart_jenis == 2">
                        <GChart 
                        type="ColumnChart" 
                        :data="chart_data" 
                        :options="{ title: chart_title, legend: { position: 'right' },  width: 1250,
                        height: 575, }"
                        ref="gchart"
                        @ready="onChartReady"/>
                    </template>

                    <template v-else-if="chart_jenis == 3">
                        <GChart
                        type="LineChart"
                        :data="chart_data"
                        :options="{
                        title: chart_title,
                        curveType: 'function',
                        legend: { position: 'bottom' },
                        chartArea: { left: 50, right: 20, top: 40, bottom: 60 },
                            vAxis: {
                                viewWindow: { min: 0 },
                                format: '0'
                            }
                        }"
                        ref="gchart"
                        @ready="onChartReady"
                        />
                    </template>

                    <template v-else>
                        <br><br><br><br><br>
                        <br><br><br><br><br>
                        <br><br><br><br><br>
                        
                    </template>
                </div>
            </div>
        </w-card>

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { GChart } from "vue-google-charts";

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    negeri_user: [Array, Object],
    segmenName: [Array, Object]
  },
   components: {
        GChart
    },
  data() {
    return {
      resourceurl: 'laporan.pd'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan', route: '/laporan' },
        { label: 'ART', route: 'laporan/art' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
     

      pencarian: {
         premis_id: '',
         lkp_ternakan_id: '',
         lkp_baka_id: '',
         lkp_jurusan_id: '',
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_daerah_id: '',
         lkp_art_id: '',
         bil_inseminasi: '',
         tarikh_ai: '',
         bunting: '',
         lkp_status_id: [],
         // tarikh_dari: '',
         // tarikh_hingga: '',
      },

     form_chart: {
         jenis_graf: '',
         exis_x: '',
         exis_y: '',
         tajuk: '',
         lkp_negeri_id:'',
         loading:false,
      },

      chart_data : [],
      chart_title: '',
      chart_jenis: '',

       lkp_jurusan :[],
       lkp_ternakan : [],
       lkp_baka : [],
       premis : [],
       negeri:[],
       bandar:[],
       daerah:[],
       lkp_art: [],
       lkp_status: [],
       status_bunting:[
        {value: 1, label: "BUNTING"},
        {value: 2, label: "TIDAK BUNTING"}
      ],

       perPageOptions: [5, 10, 50, 99],
       perPage: this.items.per_page || 10,

       chartReady: false,
       chartInstance: null,
      
      
    }
  },
  methods: {
     
  paginate(url) { 
    let params = {
        ...this.pencarian,
    };

    this.$inertia.get(url, params, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
    });

  },
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       params.per_page = this.perPage;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

  
    getNegeri() {
     this.$zcomm.get(this.api_service + 'lookup/negeri_user', {}).then(res => {
       this.negeri = res

       // kalau hanya ada 1 negeri (role 4), langsung set default
       if (this.negeri.length === 1) {
         this.selectedNegeri = this.negeri[0].value
         // this.getBandar(this.selectedNegeri)
         this.getDaerah(this.selectedNegeri)
       }
     })
   },
    getBandar(i){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+i, {}).then(res => {
          this.bandar = res
        })
      },
    getDaerah(i){
        this.pencarian.lkp_daerah_id = null
        this.$zcomm.get(this.api_service + 'lookup/daerah/'+i, {}).then(res => {
          this.daerah = res
        })
      },
    getPremis(){
        this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
            this.premis = res
        })
    },

    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },
    getJurusanCarian(i){
        this.pencarian.lkp_jurusan_id = null
        this.pencarian.lkp_baka_id = null
        this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },
    getBakaCarian(i){
        this.pencarian.lkp_baka_id = null
         this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
           this.lkp_baka = res
         })
       },

    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art_ai', {}).then(res => {
        this.lkp_art = res
      })
    },


   createExcel() {
      const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         lkp_daerah_id: this.pencarian.lkp_daerah_id || '',
         premis_id: this.pencarian.premis_id || '',
         lkp_ternakan_id: this.pencarian.lkp_ternakan_id || '',
         lkp_baka_id: this.pencarian.lkp_baka_id || '',
         lkp_jurusan_id: this.pencarian.lkp_jurusan_id || '',
         lkp_art_id: this.pencarian.lkp_art_id || '',
         bil_inseminasi: this.pencarian.bil_inseminasi || '',
         tarikh_ai: this.pencarian.tarikh_ai || '',
         bunting: this.pencarian.bunting || '',
         lkp_status_id: this.pencarian.lkp_status_id?.join(',') || '', // multiselect
         // per_page: this.perPage || 10,
         excel: 1 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.art') + '?' + queryString;
      window.open(url, '_blank');

    // const url = route('laporan.service.service_ai') + '?' + new URLSearchParams(params).toString();
    // window.open(url, '_blank');
   },

    changePerPage() {
        let params = {
            ...this.pencarian,
            per_page: this.perPage,
            page: 1
        };
        this.$inertia.visit(route(route().current(), params), {
            preserveState: true,
            preserveScroll: true,
        });
    },



    validateFormChart() {
      this.loading=true;
      let isValid = true;
         
      if(!this.form_chart.jenis_graf ||  !this.form_chart.exis_x || !this.form_chart.exis_y || !this.form_chart.tajuk){
         isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        this.loading=false;
        return false;
      }
      // this.datas.hantar = 1;
      this.getChart();
    },


    getChart(){
        this.$zcomm.get('laporan.chart_art', {jenis_graf:this.form_chart.jenis_graf, exis_x:this.form_chart.exis_x, exis_y:this.form_chart.exis_y, tajuk:this.form_chart.tajuk, lkp_negeri_id:this.form_chart.lkp_negeri_id}).then(res => {
            // Format ulang data untuk Google Chart
            let datas = [["Nama", "Jumlah"]]; // header wajib
            if (res.length > 0 && res[0].datas) {
                res[0].datas.forEach(item => {
                    datas.push([item.nama, parseInt(item.jumlah) || 0]);
                });
            }
            this.chart_data = datas;
            this.chart_title = res[0].tajuk;
            this.chart_jenis = res[0].jenis_graf;
        });
    },
    

    onChartReady(chart, google) {
        this.chartInstance = chart; 
        this.chartReady = true;
    },

    downloadChart() {
        if (!this.chartReady || !this.chartInstance) {
            alert('Carta belum dijana sepenuhnya');
            return;
        }
        // const imageURI = this.chartInstance.getImageURI();
        const imageURI = this.chartInstance.getImageURI({
            width: 2000,
            height: 1200
        });

        const link = document.createElement('a');
        link.href = imageURI;
        link.download = (this.chart_title || 'chart') + '.png';
        link.click();
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art', {}).then(res => {

        // tambah option pilih semua
        this.lkp_status = [
          { label: ' -- SEMUA --', value: 'all' },
          ...res
        ]

      })
    },


  },

  watch: {

  },

  mounted() {
    this.getNegeri(); 
    this.getPremis();
    this.getTernakan();
    this.getArt();
    this.getStatus();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.per-page-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.per-page-label {
  font-weight: 500;
  font-size: 14px;
  color: #333;
}

.per-page-select {
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.per-page-select:hover {
  border-color: #007bff;
  box-shadow: 0 0 4px rgba(0, 123, 255, 0.4);
}

.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}

.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
